import { markRaw } from 'vue';
import { mapActions, mapState } from 'vuex';
import { PriceChangeChart } from '@/utils/chart-models';
import { applyChartTheme } from '@/utils/chart-theme';

export default {
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  computed: {
    ...mapState('app', ['resolvedTheme']),
  },
  watch: {
    resolvedTheme() {
      applyChartTheme(this.chart);
    },
  },
  methods: {
    ...mapActions('chart', ['getContractChartData']),
    createChart(data) {
      if (data) {
        setTimeout(() => {
          this.renderChart(data);
        }, PriceChangeChart.renderTimeout());
      }
    },
    renderChart(data) {
      if (!this.$refs.chart) return;
      const chart = new PriceChangeChart(this.contract, data);
      this.chart = markRaw(chart.draw(this.$refs.chart));
      applyChartTheme(this.chart);
    },
  },
  mounted() {
    const payload = {
      contractId: this.contract.contractId,
    };
    this.getContractChartData(payload).then((data) => this.createChart(data));
  },
  beforeUnmount() {
    this.chart?.destroy();
  },
};
